import { ReferenceCrud } from "@/components/admin/ReferenceCrud";

const CURRENCIES = ["EUR", "USD", "GBP", "CHF", "JPY"].map((c) => ({ value: c, label: c }));

const FIELDS = [
  { name: "name", label: "Supplier name", required: true, max: 160 },
  { name: "code", label: "Supplier code", required: true, max: 20, hint: "Letters, digits and dashes — unique", placeholder: "MAISON-01" },
  { name: "contact_name", label: "Contact person", max: 120 },
  { name: "email", label: "Email", type: "email", optional: true, nullable: true, max: 120 },
  { name: "phone", label: "Phone", max: 40 },
  { name: "country", label: "Country", max: 80 },
  { name: "currency", label: "Invoice currency", type: "select", default: "EUR", options: CURRENCIES, hint: "Purchase order costs are captured in this currency" },
  { name: "payment_terms", label: "Payment terms", max: 120, placeholder: "Net 30" },
  { name: "address", label: "Address", type: "textarea", rows: 2, span: 2, max: 400 },
  { name: "notes", label: "Internal notes", type: "textarea", rows: 3, span: 2, max: 2000 },
];

const COLUMNS = [
  { key: "name", label: "Supplier" },
  { key: "code", label: "Code", render: (s) => <span className="font-mono text-xs">{s.code}</span> },
  { key: "contact_name", label: "Contact", render: (s) => <span>{s.contact_name || <span className="text-muted-foreground">—</span>}{s.email && <span className="block text-xs text-muted-foreground">{s.email}</span>}</span> },
  { key: "country", label: "Country" },
  { key: "currency", label: "Currency" },
  { key: "payment_terms", label: "Terms" },
];

export default function AdminSuppliers() {
  return <ReferenceCrud resource="suppliers" label="Supplier" eyebrow="Purchasing" description="Maisons, distributors and ateliers you buy from. Suppliers referenced by purchase orders can be archived but not deleted." fields={FIELDS} columns={COLUMNS} writePerm="purchasing.write" searchPlaceholder="Search by name, code or contact…" />;
}
